import angular from 'angular'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'

import { getFeatures } from '~/featureFlags'

const newTemplateId = 'react-LockActions'

const Link = (reduxStore) => (scope, el) => {
  const rootEl = el[0]

  scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootEl))

  getFeatures().then((features) => {
    if (features.isEnabled('draftApiStateful') && !scope.vm.lockObj.isMyLock) {
      Promise.all([
        import(
          /* webpackChunkName: 'stateful-lock-actions' */ '~/reactapp/App/LockActions'
        ),
        import(/* webpackChunkName: 'graphql-client' */ '~/graphql/client'),
      ]).then((imports) => {
        const { default: LockActions } = imports[0]
        const { default: client } = imports[1]
        ReactDOM.render(
          <ApolloProvider client={client}>
            <Provider store={reduxStore}>
              <LockActions
                documentId={scope.vm.storyObj._id}
                story={scope.vm.storyObj}
              />
            </Provider>
          </ApolloProvider>,
          rootEl
        )
      })
    }
  })
}

function Controller() {
  // Empty controller
}

function directive(reduxStore) {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template: `<div id="${newTemplateId}"/>`,
    scope: {
      storyObj: '<',
      lockObj: '<',
    },
    controller: Controller,
    link: Link(reduxStore),
  }
}

export default angular
  .module('ellipsis.statefulLockActions', [])
  .directive('statefulLockActions', ['$ngRedux', directive])
